import { FormData } from './Incidents'
import React, { ReactElement } from 'react'
import { Icon } from '../../components/Icon'

export const checkValidation = (formData: FormData) => {
  if (
    formData.candidate == '' ||
    formData.severity_level == '' ||
    formData.overview == '' ||
    formData.status == ''
  ) {
    return true
  } else {
    return false
  }
}

export const calculatePageCount = (dataLength: number): number => {
  if (dataLength < 4) {
    return 1
  } else {
    return Math.ceil(dataLength / 3)
  }
}

export const initialData = {
  candidate: '',
  employer: '',
  severity_level: '',
  overview: '',
  status: 'open',
  immediateActionTaken: '',
  furtherActionRequired: '',
  monitoringRequired: '',
  conclusionOfOutcome: '',
}

interface Props {
  severity_level: 'well-being' | 'serious' | 'minor' | string
}

export const SeverityIcon: React.FC<Props> = ({
  severity_level,
}): ReactElement => {
  let icon: ReactElement
  let color: string
  let text: string

  switch (severity_level) {
    case 'well-being':
      icon = (
        <Icon
          name={'IconAlertTriangle'}
          width={13.33}
          height={13.33}
          strokeWidth={1.2}
          stroke={'#02698C'}
        />
      )
      color = 'text-bluishGreen'
      text = 'Well Being'
      break
    case 'serious':
      icon = (
        <Icon
          name={'IconAlertTriangle'}
          width={13.33}
          height={13.33}
          strokeWidth={1.5}
          stroke={'#FF6666'}
        />
      )
      color = 'text-textError'
      text = 'Serious'
      break
    case 'minor':
      icon = (
        <Icon
          name={'IconAlertCircle'}
          width={13.33}
          height={13.33}
          strokeWidth={1.2}
          stroke={'#FFA800'}
        />
      )
      color = 'text-goldYellow'
      text = 'Minor'
      break
    default:
      icon = <></>
      color = ''
      text = ''
      break
  }

  return (
    <div className="flex items-center gap-3">
      {icon}
      <p className={`font-semibold text-sm leading-6 ${color}`}>{text}</p>
    </div>
  )
}
